var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.containerClassNames},[(_vm.svgIcon)?_c('SVGIcon',{staticClass:"PWBIcon__icon",attrs:{"icon":_vm.svgIconName}}):_c('b-icon',{staticClass:"PWBIcon__icon",attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }